var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"terms"},[_c('div',{staticClass:"description",domProps:{"innerHTML":_vm._s(_vm.pageText)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }